import { ApiClientInstance } from '@shared/api';

import { TRedeemRewardResponse } from './types';

export const RedeemAwardCode = (data: string) => {
  return ApiClientInstance.post<string, TRedeemRewardResponse>('v2/club/rewards/redeem', data);
};
